var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Tjerat05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487 443",
    style: {
      enableBackground: "new 0 0 487 443"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#010202;}\n\t.st2{fill:#bee8ff;}\n\t.st3{opacity:0.129;}\n\t.st4{fill:none;stroke:#010202;stroke-width:6.5416;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#010202;stroke-width:6.8851;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#010202;stroke-width:6.0779;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#010202;stroke-width:6.6192;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#010202;stroke-width:6.1122;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#010202;stroke-width:6.3794;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#010202;stroke-width:6.3794;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#010202;stroke-width:5.9409;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#010202;stroke-width:6.2218;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#010202;stroke-width:3.0422;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#010202;stroke-width:3.2188;stroke-miterlimit:10;}\n\t.st15{fill:#84CEEF;}\n\t.st16{fill:none;stroke:#FFFFFF;strokeWidth:11.7826;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;strokeWidth:11.7845;stroke-miterlimit:10.0016;}\n\t.st18{fill:none;stroke:#010202;stroke-width:5.8913;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#040506;stroke-width:6.2099;stroke-miterlimit:10;}\n\t.st20{fill:#9ACAEE;}\n\t.st21{fill:none;stroke:#040505;stroke-width:6.2099;stroke-miterlimit:10;}\n\t.st22{fill:#040505;}\n\t.st23{fill:#FFFFFF;stroke:#040505;stroke-width:6.2415;stroke-miterlimit:10;}\n\t.st24{fill:#FFFFFF;stroke:#040505;stroke-width:7.0529;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    transform: "translate(-198.04 140.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    transform: "translate(511.344 -138.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    className: "st15",
    d: "M-22.91,22.48c-72.09-18.13-153.17,8.77-201.9,61.38c-47.79,52.96-66.84,125.86-51.07,195.43 c17.3,77.53,96.99,136.68,158.48,143.75c99.89,11.42,181.82-33.29,207.31-62.02c46.97-52.94,68.23-126.16,50.85-192.85 S65.51,44.72-22.91,22.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    className: "st2",
    d: "M-85.63,429.87c-10.8,0.01-21.6-0.61-32.33-1.83c-64.36-7.36-145.15-68.46-162.82-147.65 c-15.96-71.18,3.51-145.69,52.27-199.96C-176.89,24.71-93.79-0.54-21.69,17.6c86.05,21.64,148.61,77.45,167.31,149.3 c17.26,66.22-2.65,141.88-51.95,197.47C67.62,393.75-2.3,429.87-85.63,429.87z M-69.61,21.84 c-57.32,0.2-112.06,23.84-151.5,65.43c-46.52,51.81-65.09,122.94-49.83,190.88C-254.2,353.17-177.73,411.03-116.8,418 c102.48,11.73,181-35.6,202.96-60.35c47.13-53.1,66.17-125.23,49.75-188.23C118.11,101.19,58.29,48.05-24.14,27.34l0,0 C-39.01,23.65-54.29,21.8-69.61,21.84L-69.61,21.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    transform: "translate(36.205 0.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    x: -306.92,
    y: 218.24,
    transform: "matrix(0.0206 -0.9998 0.9998 0.0206 -320.9433 112.2284)",
    className: "st2",
    width: 407.46,
    height: 3.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    transform: "translate(3.787 26.134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    x: -66.28,
    y: -58,
    transform: "matrix(0.0184 -0.9998 0.9998 0.0184 -208.4184 77.7653)",
    className: "st2",
    width: 3.36,
    height: 406.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    transform: "translate(2.044 45.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    x: -74.78,
    y: 37.44,
    transform: "matrix(0.018 -0.9998 0.9998 0.018 -312.2376 163.0813)",
    className: "st2",
    width: 3.36,
    height: 406.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    transform: "translate(15.819 0.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    className: "st2",
    d: "M-81.21,422.94c-0.18,0-0.36-0.03-0.54-0.09c-45.95-15.38-81.01-50.12-104.13-103.27 c-24.9-57.27-29.67-118.37-13.43-172.03c18.17-59.1,60.81-107.57,117.12-133.11c0.47-0.21,1.01-0.2,1.47,0.04 C-2.22,56.16,35.92,117.98,35.92,203.47c0,133.14-39.19,178.34-116.37,219.3C-80.68,422.88-80.95,422.94-81.21,422.94z  M-81.57,17.82c-55.06,25.24-96.73,72.78-114.52,130.68c-16,52.92-11.28,113.2,13.3,169.74c22.61,51.97,56.72,86.01,101.42,101.2 C-5.79,379.2,32.57,334.55,32.57,203.45C32.58,119.61-4.76,58.86-81.57,17.84L-81.57,17.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    transform: "translate(510.767 -138.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    className: "st16",
    d: "M-25.73,22.5c-72.1-18.13-153.17,8.78-201.91,61.38c-47.79,52.97-66.83,125.86-51.04,195.43 c17.29,77.54,96.98,136.72,158.48,143.75c99.89,11.44,181.81-33.28,207.3-62.01c46.97-52.95,68.23-126.17,50.85-192.86 S62.68,44.74-25.73,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    className: "st16",
    d: "M-88.44,429.89c-10.8,0-21.6-0.61-32.33-1.83c-64.37-7.37-145.16-68.46-162.83-147.65 c-15.97-71.18,3.51-145.7,52.27-199.96C-179.71,24.74-96.61-0.52-24.51,17.61c86.04,21.64,148.6,77.46,167.31,149.3 c17.27,66.23-2.64,141.89-51.95,197.47C64.8,393.77-5.15,429.89-88.44,429.89z M-72.43,21.85 c-57.32,0.19-112.06,23.84-151.5,65.43c-46.53,51.82-65.09,122.96-49.83,190.91c16.73,75.01,93.21,132.86,154.13,139.83 c102.48,11.74,181-35.6,202.97-60.35c47.13-53.09,66.16-125.22,49.75-188.23C115.3,101.22,55.46,48.09-26.97,27.38l0,0 C-41.84,23.68-57.11,21.82-72.43,21.85L-72.43,21.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    transform: "translate(36.204 0.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    x: -309.75,
    y: 218.26,
    transform: "matrix(0.0206 -0.9998 0.9998 0.0206 -323.7368 109.4258)",
    className: "st16",
    width: 407.46,
    height: 3.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    transform: "translate(3.786 26.135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    x: -69.11,
    y: -57.97,
    transform: "matrix(0.0184 -0.9998 0.9998 0.0184 -211.218 74.9626)",
    className: "st16",
    width: 3.36,
    height: 406.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    transform: "translate(2.043 45.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    x: -77.6,
    y: 37.46,
    transform: "matrix(0.018 -0.9998 0.9998 0.018 -315.0334 160.2738)",
    className: "st17",
    width: 3.36,
    height: 406.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    transform: "translate(15.819 0.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    className: "st16",
    d: "M-84.04,422.94c-0.18,0-0.35-0.03-0.52-0.08c-45.95-15.38-81.01-50.14-104.13-103.28 c-24.9-57.26-29.67-118.37-13.44-172.03c18.16-59.11,60.81-107.59,117.12-133.14c0.47-0.21,1.02-0.2,1.47,0.05 C-5.05,56.13,33.1,117.95,33.1,203.45c0,133.14-39.19,178.32-116.37,219.29C-83.5,422.87-83.77,422.94-84.04,422.94z  M-84.4,17.82c-55.07,25.24-96.74,72.79-114.53,130.69c-16,52.92-11.28,113.19,13.31,169.73c22.6,51.97,56.72,86.01,101.42,101.2 c75.58-40.21,113.98-84.86,113.98-215.95c0-83.87-37.37-144.63-114.17-185.64L-84.4,17.82z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    className: "st18",
    cx: 441.41,
    cy: 82.2,
    rx: 224.42,
    ry: 218.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Tjerat05);
export default __webpack_public_path__ + "static/media/3tjerat-05.606f28e0c2c4f912691e083ca02ebcd9.svg";
export { ForwardRef as ReactComponent };